import { createContext, type Dispatch, type SetStateAction } from 'react';

const TabsContext = createContext(
  {} as {
    activeTabId: string | null;
    setActiveTabId: Dispatch<SetStateAction<string | null>>;
  },
);

export { TabsContext };
